import '../styles/About.css'

export default function About() {
  return (
    <section className="about">
        <h2 className="about__titulo">¿Que es Pretty Woman?</h2>
        <p className="about__texto">
            Somos la mejor agencia Latinoamérica de streamers, con los mejores tutores, líderes y 
            capacitadores quienes están dispuestos a guiarte en todo el camino al éxito dentro de 
            la empresa. Contamos con algunos beneficios para nuestro equipo de trabajo como son los 
            cursos de ingles, medico virtual, capacitaciones, talleres con nuestra psicóloga y 
            entrenamientos funcionales.
        </p>
        <h2 className="about__titulo">¿De donde nace Pretty Woman?</h2>
        <p className="about__texto">
            Nacemos al ver la necesidad que tienen muchas mujeres de generar sus propios ingresos, siendo 
            ellas mismas las dueñas de su propio horario y de esta forma estamos fomentando empleos a miles 
            de mujeres, no solo en Latinoamérica si no en varias partes del mundo, respetando sus limites y 
            forma de pensar para que generen excelentes ingresos semanales desde su celular.
        </p>
        <h2 className="about__titulo">¿Que es una Streamer?</h2>
        <p className="about__texto">
            Es una persona capaz de transmitir contenido audio visual en tiempo real desde un dispositivo 
            móvil inteligente generando ganancias mientras interactúa con diferente tipos de usuarios y 
            conoce nuevas culturas.
        </p>
    </section>
  );
}